<template>
  <v-skeleton-loader
    v-if="loading"
    type="list-item-three-line"
  />
  <v-card
    v-else
  >
    <v-form
      validate-on="eager"
    >
      <v-card-title>
        Presentation schedule options
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="6"
            >
              <v-text-field
                id="minimum-presentation-seconds"
                v-model="schedule.minimumPresentationSeconds"
                label="Min Presentation Time (seconds)"
                class="adjust-label"
                :rules="[
                  rules.cannotBeNegativeValue,
                  rules.mustBeAWholeNumber,
                  rules.isLessThanMaxValue,
                ]"
              />
            </v-col>
            <v-col
              cols="6"
            >
              <v-text-field
                id="maximum-presentation-seconds"
                v-model="schedule.maximumPresentationSeconds"
                label="Max Presentation Time (seconds)"
                class="adjust-label"
                :rules="[
                  rules.cannotBeNegativeValue,
                  rules.mustBeAWholeNumber,
                  rules.isGreaterThanMinValue,
                ]"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                id="maximum-total-minutes"
                v-model="schedule.maximumTotalMinutes"
                label="Total Presentations Duration (minutes)"
                class="adjust-label"
                :rules="[rules.cannotBeNegativeValue, rules.mustBeAWholeNumber]"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                id="presentation-buffer-seconds"
                v-model="schedule.presentationBufferSeconds"
                label="Buffer (seconds) between presentations"
                class="adjust-label"
                :rules="[rules.cannotBeNegativeValue, rules.mustBeAWholeNumber]"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                id="lunch-minutes"
                v-model="schedule.lunchMinutes"
                label="How long is lunch (minutes)?"
                class="adjust-label"
                :rules="[rules.cannotBeNegativeValue, rules.mustBeAWholeNumber]"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="6"
            >
              <v-text-field
                id="breaks"
                v-model="schedule.breaks"
                label="How many additional breaks?"
                class="adjust-label"
                :rules="[rules.cannotBeNegativeValue, rules.mustBeAWholeNumber]"
              />
            </v-col>
            <v-col
              cols="6"
            >
              <v-text-field
                id="break-minutes"
                v-model="schedule.breakMinutes"
                label="Break duration (minutes)"
                class="adjust-label"
                :rules="[rules.cannotBeNegativeValue, rules.mustBeAWholeNumber]"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn
          @click="submit"
        >
          Save scheduling options
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import AdminClient from '@/api/AdminClient';
import { mapGetters } from 'vuex';

export default {
  name: 'AdminCustomizeScheduleOptions',
  data() {
    return {
      loading: false,
      schedule: {
        minimumPresentationSeconds: null,
        maximumPresentationSeconds: null,
        maximumTotalMinutes: null,
        presentationBufferSeconds: null,
        lunchMinutes: null,
        breaks: null,
        breakMinutes: null,
      },
      rules: {
        isGreaterThanMinValue: (value) => (value !== ''
        /* eslint-disable-next-line max-len */
          && Number(this.schedule.maximumPresentationSeconds) > Number(this.schedule.minimumPresentationSeconds))
          || 'Value must be GREATER than the min presentation time.',
        isLessThanMaxValue: (value) => (value !== ''
        /* eslint-disable-next-line max-len */
          && Number(this.schedule.maximumPresentationSeconds) >= Number(this.schedule.minimumPresentationSeconds))
          || 'Value must be LESS than the max presentation time.',
        cannotBeNegativeValue: (value) => value >= 0
          || 'Value cannot be negative.',
        mustBeAWholeNumber: (value) => (value !== '' && value !== '' && Number.isInteger(Number(value)))
          || 'Value must be a whole number.',
      },
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
    }),
  },
  async mounted() {
    this.eventId = this.$store.state.hackathonID || null;
    await this.getScheduleOptions();
  },
  methods: {
    async getScheduleOptions() {
      try {
        const adminClient = new AdminClient(this.currentJwtToken);
        const response = await adminClient.getScheduleOptions(this.eventId);
        if (response !== undefined) {
          // then we should populate the data
          Object.keys(response).forEach((option) => {
            if (option !== 'options') {
              this.schedule[option] = response[option];
            }
          });
          this.schedule.breaks = response.breakCount;
        }
      } catch (err) {
        console.log('err is', err);
      }
    },
    async submit() {
      this.loading = true;
      const adminClient = new AdminClient(this.currentJwtToken);
      const response = await adminClient.updateScheduleOptions(this.eventId, this.schedule);
      const isSuccess = response.status === 204;
      if (isSuccess) {
        this.$router.go(); // reload to refresh all relevant data
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .v-card__subtitle+.v-card__text {
      padding: 0;
    }

    .v-messages.error--text .v-messages__message {
      color: #ba1a1a;
    }
  }
</style>
